import server from "./server";

export const getCurrenciesApi = async () => {
  const response = await server().get("/currencies");
  return response.data;
};
